import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_btn_expand",
  "use": "lc_btn_expand-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_btn_expand\"><defs><style type=\"text/css\"></style></defs><path d=\"M338.3 919.8L737 555.2a57.377 57.377 0 0 0 19.5-43.1c0-16.5-7.1-32.2-19.5-43.1l-398.7-364.6c-18.8-17.8-46.2-23.3-70.4-14.1s-41.1 31.4-43.4 57.2L224.49999999 876.4c2.2 25.9 19 48.2 43.30000001 57.4 24.3 9.3 51.7 3.8 70.5-14z\" p-id=\"2949\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol